import { Permission, PermissionGroup } from '../type/entities/role-type';

const matchesPermissionSearch = (permission: Permission, search: string): boolean => {
    const normalizedSearch = search.toLowerCase();

    return (
        permission.label.toLowerCase().includes(normalizedSearch) ||
        permission.description?.toLowerCase().includes(normalizedSearch) ||
        permission.action?.toLowerCase().includes(normalizedSearch)
    );
};

export const filterPermissionGroups = (
    groups: PermissionGroup[],
    groupSearch: string,
    permissionSearch: string
): PermissionGroup[] => {
    const normalizedGroupSearch = groupSearch.trim().toLowerCase();
    const normalizedPermissionSearch = permissionSearch.trim().toLowerCase();

    return groups
        .filter((group) => {
            if (!normalizedGroupSearch) return true;
            return group.label.toLowerCase().includes(normalizedGroupSearch);
        })
        .map((group) => {
            if (!normalizedPermissionSearch) return group;

            return {
                ...group,
                permissions: group.permissions.filter((permission) =>
                    matchesPermissionSearch(permission, normalizedPermissionSearch)
                ),
            };
        })
        .filter((group) => {
            if (!normalizedPermissionSearch) return true;
            return group.permissions.length > 0;
        });
};
